var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-footer-container"},[_c('floating-buttons'),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-cta"},[_c('a',{staticClass:"footer-cta__link",attrs:{"href":"https://alvaroapoio.com.br/fale-conosco/contato"}},[_vm._v(" Solicite um orçamento ")])])
}]
render._withStripped = true
export { render, staticRenderFns }